<!-- IconForm.vue -->
<template>
  <div>
    <!--Icon Person Nuam-->
    <svg
      v-if="iconName==='person' && company === 'nuam'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 11.03 13.83"
      class="icon-form"
      :class="{ 'icon-form--filled': isFilled }"
    >
      <path
        fill="currentColor"
        d="M5.51,8.7c-2.37,0-5.51.27-5.51,2.56,0,2.57,4.15,2.57,5.51,2.57,2.37,0,5.51-.27,5.51-2.56,0-2.57-4.15-2.57-5.51-2.57ZM5.51,12.79c-2.97,0-4.47-.51-4.47-1.53s1.5-1.52,4.47-1.52,4.47.51,4.47,1.53-1.5,1.52-4.47,1.52Z"
      />
      <path
        fill="currentColor"
        d="M5.51,0C3.48,0,1.82,1.66,1.82,3.69c0,2.03,1.64,3.69,3.67,3.7h.02c2.04,0,3.7-1.66,3.7-3.7S7.55,0,5.51,0ZM5.51,6.4h-.02c-1.48,0-2.69-1.22-2.68-2.7,0-1.49,1.21-2.7,2.7-2.7s2.7,1.21,2.7,2.7-1.21,2.7-2.7,2.7Z"
      />
    </svg>
    <!--Icon Person a2censo-->
    <svg
      v-if="iconName==='person' && company === 'a2censo'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 11.03 13.87"
      class="icon-form"
      :class="{ 'icon-form--filled': isFilled }"
    >
      <path
        fill="currentColor"
        d="M5.52,6.05c-1.67,0-3.02-1.35-3.02-3.02,0-1.67,1.35-3.02,3.02-3.02,1.67,0,3.02,1.35,3.02,3.02h0c0,1.67-1.35,3.02-3.02,3.02h0ZM5.52,1.07c-1.08,0-1.96.88-1.96,1.96s.88,1.96,1.96,1.96,1.96-.88,1.96-1.96c0-1.08-.88-1.96-1.96-1.96ZM8.36,13.87H2.67c-1.72,0-2.67-.94-2.67-2.65,0-1.89,1.07-4.1,4.09-4.1h2.85c3.02,0,4.09,2.21,4.09,4.1,0,1.71-.95,2.65-2.67,2.65ZM4.09,8.18c-1.55-.12-2.9,1.04-3.02,2.59-.01.15-.01.3,0,.45,0,1.11.48,1.59,1.6,1.59h5.69c1.12,0,1.6-.47,1.6-1.59.13-1.55-1.03-2.91-2.58-3.04-.15-.01-.3-.01-.45,0h-2.85Z"
      />
    </svg>
    <!--Icon Person Bvc-->
    <svg
      v-if="iconName==='person' && company === 'bvc'"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 11 14.9"
      class="icon-form"
      :class="{ 'icon-form--filled': isFilled }"
    >
      <g>
        <g>
          <path
            fill="currentColor"
            d="M5.5,6.1c-1.7,0-3-1.3-3-3S3.8,0,5.5,0s3,1.4,3,3h0c0,1.7-1.3,3-3,3h0ZM5.5,1.1c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2ZM8.4,13.9H2.7c-1.7,0-2.7-.9-2.7-2.7s1.1-4.1,4.1-4.1h2.8c3,0,4.1,2.2,4.1,4.1s-.9,2.6-2.7,2.7ZM4.1,8.2c-1.5-.1-2.9,1-3,2.6,0,.1,0,.3,0,.4,0,1.1.5,1.6,1.6,1.6h5.7c1.1,0,1.6-.5,1.6-1.6.1-1.6-1-2.9-2.6-3-.2,0-.3,0-.4,0h-2.8,0Z"
          />
        </g>
      </g>
    </svg>
    <!--Icon Person Bsx-->
    <svg
      v-if="iconName==='person' && company === 'bsx'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 11.03 11.03"
      class="icon-form"
    >
      <g>
        <path
          fill="currentColor"
          d="M5.51,5.51c-.76,0-1.41-.27-1.95-.81-.54-.54-.81-1.19-.81-1.95s.27-1.41.81-1.95c.54-.54,1.19-.81,1.95-.81s1.41.27,1.95.81c.54.54.81,1.19.81,1.95s-.27,1.41-.81,1.95c-.54.54-1.19.81-1.95.81ZM0,11.03v-1.93c0-.39.1-.75.3-1.08.2-.33.47-.58.8-.75.71-.36,1.44-.62,2.17-.8.74-.18,1.48-.27,2.24-.27s1.5.09,2.24.27c.74.18,1.46.45,2.17.8.33.17.6.42.8.75.2.33.3.69.3,1.08v1.93H0Z"
        />
      </g>
    </svg>
    <!--Icon Person Bvl-->
    <svg
      v-if="iconName==='person' && company === 'bvl'"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 11 14.9"
      class="icon-form"
      :class="{ 'icon-form--filled': isFilled }"
    >
      <g>
        <g>
          <path
            fill="currentColor"
            d="M6.94,6.94c-.95,0-1.77-.34-2.45-1.02-.68-.68-1.02-1.5-1.02-2.45s.34-1.77,1.02-2.45,1.5-1.02,2.45-1.02,1.77.34,2.45,1.02c.68.68,1.02,1.5,1.02,2.45s-.34,1.77-1.02,2.45c-.68.68-1.5,1.02-2.45,1.02ZM0,13.87v-2.43c0-.49.13-.94.38-1.35s.59-.73,1.01-.94c.9-.45,1.81-.78,2.73-1.01.92-.22,1.86-.34,2.82-.34s1.89.11,2.82.34,1.84.56,2.73,1.01c.42.22.76.53,1.01.94s.38.86.38,1.35v2.43H0ZM1.73,12.14h10.41v-.69c0-.16-.04-.3-.12-.43-.08-.13-.18-.23-.31-.3-.78-.39-1.57-.68-2.36-.88-.79-.2-1.6-.29-2.41-.29s-1.61.1-2.41.29c-.79.2-1.58.49-2.36.88-.13.07-.23.17-.31.3-.08.13-.12.27-.12.43v.69ZM6.94,5.2c.48,0,.89-.17,1.22-.51.34-.34.51-.75.51-1.22s-.17-.89-.51-1.22c-.34-.34-.75-.51-1.22-.51s-.89.17-1.22.51c-.34.34-.51.75-.51,1.22s.17.89.51,1.22c.34.34.75.51,1.22.51Z"
          />
        </g>
      </g>
    </svg>
    <!--Icon Email nuam-->
    <svg
      v-if="iconName==='email' && company === 'nuam'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.06 11.84"
      class="icon-form"
      :class="{ 'icon-form--filled': isFilled }"
    >
      <path
        fill="currentColor"
        d="M6.55,6.96c-.41,0-.81-.13-1.15-.4l-2.72-2.2c-.2-.16-.23-.44-.07-.64.16-.2.44-.23.64-.07l2.72,2.19c.34.27.82.27,1.17,0l2.69-2.19c.2-.16.48-.13.64.07.16.2.13.48-.07.64l-2.7,2.19c-.34.27-.75.41-1.16.41Z"
      />
      <path
        fill="currentColor"
        d="M3.54,11.84c-.94,0-1.78-.34-2.42-.98-.72-.72-1.12-1.73-1.12-2.85V3.84C0,1.65,1.52,0,3.55,0h5.96c2.02,0,3.55,1.65,3.55,3.84v4.17c0,1.12-.4,2.13-1.12,2.85-.65.64-1.48.98-2.42.98H3.54ZM3.55,10.93h5.96s0,0,0,0c.69,0,1.31-.25,1.78-.72.55-.55.85-1.33.85-2.2V3.84c0-1.7-1.11-2.93-2.64-2.93H3.55C2.02.91.91,2.14.91,3.84v4.17c0,.88.3,1.66.85,2.2.47.47,1.09.72,1.78.72h0Z"
      />
    </svg>
    <!--Icon Email a2censo-->
    <svg
      v-if="iconName==='email' && company === 'a2censo'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.03 9.93"
      class="icon-form"
      :class="{ 'icon-form--filled': isFilled }"
    >
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M11.89,0H1.15C.51,0,0,.51,0,1.15v7.64c0,.63.51,1.15,1.15,1.15h10.74c.63,0,1.15-.51,1.15-1.15V1.15c0-.63-.51-1.15-1.15-1.15ZM11.73.76l-5.19,5.19L1.31.76h10.42ZM.76,1.3v7.32l3.68-3.68L.76,1.3ZM1.3,9.16l3.68-3.68,1.29,1.28c.15.15.39.15.54,0l1.26-1.26,3.66,3.66H1.3ZM8.61,4.96l3.66,3.66V1.3l-3.66,3.66Z"
      />
    </svg>
    <!--Icon Email Bvc-->
    <svg
      v-if="iconName==='email' && company === 'bvc'"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 13 11.4"
      :class="{ 'icon-form--filled': isFilled }"
      class="icon-form"
    >
      <g>
        <g>
          <path
            fill="currentColor"
            d="M13,3.7l-1.9-1.3V.4c0-.2-.2-.3-.4-.4H2.5c-.2,0-.3.2-.4.4v1.9L.1,3.7c0,0-.1.1-.1.2v7.1c0,.2.2.4.4.4h12.4c.2,0,.2-.2.2-.4V3.9c0,0,0-.2,0-.2h0ZM11.1,3l1.3.9-1.3,1v-1.9h0ZM2.7.6h7.8v4.8l-3.9,2.9-3.9-2.9V.6h0ZM2.1,3v1.9l-1.3-1s1.3-.9,1.3-.9ZM.6,4.5l4.2,3.2L.6,10.6v-6ZM1.3,10.8l4-2.7,1.1.8c0,0,.1,0,.2,0s0,0,.2,0l1.1-.9,4,2.7H1.3ZM12.4,10.4l-4.1-2.8,4.1-3.2v5.9h0Z"
          />
          <path
            fill="currentColor"
            d="M4.2,2.5h1.3c.2,0,.3-.1.3-.3s-.1-.3-.3-.3h-1.3c-.2,0-.3.1-.3.3s.1.3.3.3Z"
          />
          <path
            fill="currentColor"
            d="M4.2,3.9h4.8c.2,0,.3-.1.3-.3s-.1-.3-.3-.3h-4.8c-.2,0-.3.1-.3.3s.1.3.3.3Z"
          />
          <path
            fill="currentColor"
            d="M9.3,4.9c0-.2-.1-.3-.3-.3h-4.8c-.2,0-.3.1-.3.3s.1.3.3.3h4.8c.2,0,.3-.1.3-.3Z"
          />
        </g>
      </g>
    </svg>
    <!--Icon Email bsx-->
    <svg
      v-if="iconName==='email' && company === 'bsx'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 13.03 10.43"
      class="icon-form"
    >
      <g>
        <path
          fill="currentColor"
          d="M1.3,10.43c-.36,0-.67-.13-.92-.38-.26-.26-.38-.56-.38-.92V1.3c0-.36.13-.67.38-.92.26-.26.56-.38.92-.38h10.43c.36,0,.67.13.92.38.26.26.38.56.38.92v7.82c0,.36-.13.67-.38.92-.26.26-.56.38-.92.38H1.3ZM6.52,5.86l5.21-3.26v-1.3l-5.21,3.26L1.3,1.3v1.3l5.21,3.26Z"
        />
      </g>
    </svg>
    <!--Icon Email Bvl-->
    <svg
      v-if="iconName==='email' && company === 'bvl'"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 13.87 11.1"
      :class="{ 'icon-form--filled': isFilled }"
      class="icon-form"
    >
      <g>
        <g>
          <path
            fill="currentColor"
            d="M1.39,11.1c-.38,0-.71-.14-.98-.41-.27-.27-.41-.6-.41-.98V1.39c0-.38.14-.71.41-.98.27-.27.6-.41.98-.41h11.1c.38,0,.71.14.98.41.27.27.41.6.41.98v8.32c0,.38-.14.71-.41.98-.27.27-.6.41-.98.41H1.39ZM6.94,6.24L1.39,2.77v6.94h11.1V2.77l-5.55,3.47ZM6.94,4.86l5.55-3.47H1.39l5.55,3.47ZM1.39,2.77v-1.39,8.32V2.77Z"
          />
        </g>
      </g>
    </svg>
    <!--Icon Phone nuam-->
    <svg
      v-if="iconName==='phone' && company === 'nuam'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14.13 14.13"
      class="icon-form"
      :class="{ 'icon-form--filled': isFilled }"
    >
      <path
        fill="currentColor"
        d="M12.81,8.9c-.18-.17-.37-.35-.58-.56-1.01-1.01-1.83-.72-2.49-.49-.72.25-1.34.47-2.64-.83-1.3-1.3-1.08-1.92-.83-2.64.23-.66.52-1.48-.49-2.49-.21-.21-.39-.4-.56-.58C4.53.59,3.98,0,3.21,0c-.67,0-1.33.39-2.32,1.38-.01.01-.05.05-.07.07C.6,1.67,0,2.25,0,3.39c-.01,1.72,1.36,3.97,4.07,6.68,2.7,2.7,4.94,4.07,6.66,4.07,0,0,.01,0,.02,0,1.14,0,1.72-.6,1.94-.83l.07-.06c.99-.99,1.39-1.66,1.38-2.32-.01-.77-.59-1.32-1.32-2.02ZM12.06,12.47s-.07.06-.12.11c-.16.17-.5.51-1.2.52,0,0,0,0-.01,0-.99,0-2.82-.66-5.92-3.76C1.68,6.21,1.03,4.38,1.03,3.39c0-.71.35-1.04.52-1.2.04-.04.08-.08.08-.08,0,0,0,0,0,0,.73-.73,1.26-1.07,1.57-1.08.33,0,.73.42,1.28,1,.18.19.37.39.58.6.55.55.45.82.24,1.41-.29.82-.68,1.95,1.08,3.71,1.76,1.76,2.89,1.36,3.71,1.07.59-.21.87-.3,1.41.24.21.21.41.4.59.58.58.55,1,.95,1,1.28,0,.33-.35.84-1.03,1.53Z"
      />
    </svg>
    <!--Icon Phone a2censo-->
    <svg
      v-if="iconName==='phone' && company === 'a2censo'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.03 13.03"
      class="icon-form"
      :class="{ 'icon-form--filled': isFilled }"
    >
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M11.08,7.99l1.62,1.62c.45.45.45,1.17,0,1.62l-.59.59c-1.61,1.61-4.23,1.61-5.84,0L1.21,6.76c-1.61-1.61-1.61-4.23,0-5.84l.59-.59c.45-.45,1.17-.45,1.62,0l1.62,1.61c.45.45.45,1.18,0,1.62l-.74.74c-.34.34-.34.89,0,1.23l3.19,3.2c.34.34.89.34,1.23,0l.74-.74c.45-.45,1.17-.45,1.62,0ZM2.88.88c-.15-.15-.39-.15-.54,0l-.27.27,2.16,2.16.27-.27c.15-.15.15-.39,0-.54l-1.62-1.61ZM6.81,11.28L1.75,6.22c-1.25-1.25-1.31-3.2-.21-4.53l2.15,2.15c-.57.64-.54,1.62.07,2.23l3.19,3.19h0c.61.61,1.59.64,2.23.07l2.15,2.15c-1.32,1.1-3.28,1.04-4.53-.21ZM11.89,10.96l.27-.27c.15-.15.15-.39,0-.54l-1.62-1.62c-.15-.15-.39-.15-.54,0l-.27.27,2.16,2.16Z"
      />
    </svg>
    <!--Icon Phone bvc-->
    <svg
      v-if="iconName==='phone' && company === 'bvc'"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 13 13.1"
      :class="{ 'icon-form--filled': isFilled }"
      class="icon-form"
    >
      <g>
        <g id="Información">
          <path
            fill="currentColor"
            d="M10.3,8.1c-.3-.3-.6-.4-.9-.4s-.7.2-.9.4l-.9.9c0,0-.1,0-.2-.1,0,0-.2-.1-.3-.1-.8-.5-1.6-1.2-2.3-2.1-.3-.4-.6-.8-.7-1.2.2-.2.4-.4.6-.6,0,0,.2-.2.2-.2.6-.6.6-1.3,0-1.9l-.8-.8c0,0-.2-.2-.3-.3-.2-.2-.3-.4-.5-.5-.3-.3-.6-.4-.9-.4s-.7.1-.9.4q-.2.2,0,0l-.9.9C.3,2.5,0,2.9,0,3.4c0,.8.2,1.5.3,2,.4,1.2,1.1,2.3,2.1,3.5,1.2,1.4,2.7,2.6,4.3,3.4.6.3,1.5.7,2.4.7h.2c.6,0,1.2-.2,1.6-.7h0c.1-.2.3-.3.5-.5.1-.1.2-.2.4-.4.3-.3.4-.6.4-.9s-.1-.7-.4-.9c0,0-1.5-1.5-1.5-1.5ZM11.3,11h0c-.1.1-.2.2-.3.3-.2.2-.4.4-.5.6-.3.3-.6.4-1,.4h-.1c-.8,0-1.6-.4-2.2-.6-1.6-.8-2.9-1.8-4.1-3.2-.9-1.1-1.6-2.2-2-3.3-.3-.7-.4-1.2-.3-1.7,0-.3.2-.6.4-.8l.9-.9c.1-.1.3-.2.4-.2s.3.1.4.2h0c.2.2.3.3.5.5s.2.2.3.3l.8.8c.3.3.3.6,0,.8l-.2.2c-.2.2-.5.5-.7.7,0,0,0,0,0,0-.2.2-.2.5-.1.6h0c.2.5.5.9.9,1.5h0c.8.9,1.6,1.7,2.4,2.2.1,0,.2.1.3.2,0,0,.2.1.3.1,0,0,0,0,0,0,0,0,.2,0,.3,0,.2,0,.4-.1.4-.2l.9-.9c0,0,.2-.2.4-.2s.3.1.4.2q0,0,0,0l1.5,1.5c.3.3.3.6,0,.9h0Z"
          />
          <path
            fill="currentColor"
            d="M7,3.1c.7.1,1.4.5,1.9,1,.5.5.9,1.2,1,1.9,0,.2.2.3.4.3h0c.2,0,.3-.2.3-.4-.1-.9-.6-1.7-1.2-2.3s-1.4-1-2.3-1.2c-.2,0-.4,0-.4.3s0,.4.3.4h0Z"
          />
          <path
            fill="currentColor"
            d="M13,5.8c-.2-1.4-.9-2.8-2-3.8-1-1-2.4-1.7-3.8-2-.2,0-.4.1-.4.3,0,.2,0,.4.3.4,1.3.2,2.5.8,3.4,1.8.9.9,1.5,2.1,1.8,3.4,0,.2.2.3.4.3h0c.2,0,.3-.2.3-.4Z"
          />
        </g>
      </g>
    </svg>
    <!--Icon Phone bsx-->
    <svg
      v-if="iconName==='phone' && company === 'bsx'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 9.55 15"
      class="icon-form"
    >
      <defs>
        <mask
          id="mask"
          x="-3.41"
          y="-.68"
          width="16.36"
          height="16.36"
          maskUnits="userSpaceOnUse"
        >
          <g id="mask0_9_19">
            <rect
              fill="#d8d8d8"
              x="-3.41"
              y="-.68"
              width="16.36"
              height="16.36"
            />
          </g>
        </mask>
      </defs>
      <g mask="url(#mask)">
        <path
          fill="#265d7b"
          d="M1.36,15c-.38,0-.7-.13-.96-.4-.27-.27-.4-.59-.4-.96V1.36c0-.37.13-.7.4-.96.27-.27.59-.4.96-.4h6.82c.37,0,.7.13.96.4.27.27.4.59.4.96v12.27c0,.37-.13.7-.4.96-.27.27-.59.4-.96.4H1.36ZM1.36,11.59h6.82V3.41H1.36v8.18Z"
        />
      </g>
    </svg>
    <!--Icon Phone bvl-->
    <svg
      v-if="iconName==='phone' && company === 'bvl'"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 11.03 17.33"
      :class="{ 'icon-form--filled': isFilled }"
      class="icon-form"
    >
      <g>
        <g>
          <path
            fill="currentColor"
            d="M1.58,17.33c-.43,0-.8-.15-1.11-.46-.31-.31-.46-.68-.46-1.11V1.58c0-.43.15-.8.46-1.11.31-.31.68-.46,1.11-.46h7.88c.43,0,.8.15,1.11.46.31.31.46.68.46,1.11v14.18c0,.43-.15.8-.46,1.11-.31.31-.68.46-1.11.46H1.58ZM1.58,14.97v.79h7.88v-.79H1.58ZM1.58,13.39h7.88V3.94H1.58v9.45ZM1.58,2.36h7.88v-.79H1.58v.79Z"
          />
        </g>
      </g>
    </svg>
    <!--Icon checkmark-->
    <svg
      v-if="iconName==='checkmark'"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="12"
      height="12"
      viewBox="0 0 24 24"
      class="icon-checkmark"
    >
      <path
        fill="currentColor"
        d="M 20.292969 5.2929688 L 9 16.585938 L 4.7070312 12.292969 L 3.2929688 13.707031 L 9 19.414062 L 21.707031 6.7070312 L 20.292969 5.2929688 z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    isFilled: {
      type: Boolean,
      default: false
    },
    company: {
      type: String,
      required: true
    },
    iconName: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
